import * as api from "./middleware/api.middleware";
import { Environment, environmentsDetail, usersDetails } from "../interfaces";
import { getAuthHeader } from "./auth/authHeaders";
import { getScopeCustomerId } from "./activeScope";
const serviceUrl = "customers";
const getAccessToken = () => getAuthHeader();

const resolveCustomerId = (
  customer_id?: number | string | null
): number | undefined => {
  if (customer_id !== undefined && customer_id !== null && customer_id !== "") {
    const numeric = Number(customer_id);
    return Number.isNaN(numeric) ? undefined : numeric;
  }
  const stored = getScopeCustomerId();
  if (!stored) {
    return undefined;
  }
  const numeric = Number(stored);
  return Number.isNaN(numeric) ? undefined : numeric;
};

export function getEnvironmentsDetail(
  customer_id: number | string | undefined,
  environment_id: number
) {
  const resolvedCustomerId = resolveCustomerId(customer_id);
  if (resolvedCustomerId === undefined) {
    return Promise.reject(new Error("Active customer is not set"));
  }
  const getResponse =
    process.env.REACT_APP_API_URL === "http://localhost:3000/"
      ? api.get<environmentsDetail>(`data/${serviceUrl}/environment_types.json`)
      : api.get<environmentsDetail>(
          `${serviceUrl}/${resolvedCustomerId}/environments/${environment_id}`,
          getAccessToken()
        );
  return getResponse;
}

export function getEnvironments(customer_id?: number | string | null) {
  const resolvedCustomerId = resolveCustomerId(customer_id);
  if (resolvedCustomerId === undefined) {
    return Promise.reject(new Error("Active customer is not set"));
  }
  const getResponse =
    process.env.REACT_APP_API_URL === "http://localhost:3000/"
      ? api.get<Environment>(`data/${serviceUrl}/environment_types.json`)
      : api.get<Environment>(
          `${serviceUrl}/${resolvedCustomerId}/environments/`,
          getAccessToken()
        );
  return getResponse;
}

export function getCustomerDetail(customer_id?: number | string | null) {
  const resolvedCustomerId = resolveCustomerId(customer_id);
  if (resolvedCustomerId === undefined) {
    return Promise.reject(new Error("Active customer is not set"));
  }
  const getResponse =
    process.env.REACT_APP_API_URL === "http://localhost:3000/"
      ? api.get<environmentsDetail>(`data/${serviceUrl}/environment_types.json`)
      : api.get<environmentsDetail>(
          `${serviceUrl}/${resolvedCustomerId}`,
          getAccessToken()
        );
  return getResponse;
}

export function assignEnvironmentDetailsDropDown(
  customer_id?: number | string | null
) {
  const resolvedCustomerId = resolveCustomerId(customer_id);
  if (resolvedCustomerId === undefined) {
    return Promise.reject(new Error("Active customer is not set"));
  }
  return api.get<any>(
    `${serviceUrl}/${resolvedCustomerId}/environments`,
    getAccessToken()
  );
}

export function getUsersDetails(
  customer_id: number | string | undefined,
  user_id: number
) {
  const resolvedCustomerId = resolveCustomerId(customer_id);
  if (resolvedCustomerId === undefined) {
    return Promise.reject(new Error("Active customer is not set"));
  }
  const getResponse =
    process.env.REACT_APP_API_URL === "http://localhost:3000/"
      ? api.get<usersDetails>(`data/${serviceUrl}/environment_types.json`)
      : api.get<usersDetails>(
          `${serviceUrl}/${resolvedCustomerId}/users/${user_id}`,
          getAccessToken()
        );
  return getResponse;
}
